
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/templates/product-detail",
      function () {
        return require("private-next-pages/templates/product-detail.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/templates/product-detail"])
      });
    }
  